import { useRef } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useIsOverflowing } from "@/hooks/useIsOverflowing";
import { cn } from "@/lib/utils";

interface TooltipTextProps {
  text?: string;
  className?: string;
  children?: React.ReactNode;
}

export function TooltipText({ 
  text, 
  className, 
  children 
}: TooltipTextProps) {
  const textRef = useRef<HTMLDivElement>(null);
  const isOverflowing = useIsOverflowing(textRef, [text, children]);

  const content = (
    <div 
      ref={textRef}
      className={cn("truncate min-w-0", isOverflowing && "cursor-pointer", className)}
    >
      {children || text}
    </div>
  );

  if (!isOverflowing) {
    return content;
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        {content}
      </PopoverTrigger>
      <PopoverContent className="w-auto max-w-[300px] p-2" align="center">
        <p className="text-sm break-words">{children || text}</p>
      </PopoverContent>
    </Popover>
  );
}

